<template>
    <div class="container-fluid" style="background-color: white;">
        <!--submit-->
        <div class="row">
            <div class="col text-right">
                <button class="btn btn-default margin next"
                        @click="goToBackWord">
                    <icon name="backward"></icon>
                    ย้อนกลับ
                </button>
                <button class="btn btn-default margin next"
                        @click="goToForward">
                    <icon name="forward"></icon>
                    ถัดไป
                </button>
                <button class="btn btn-success margin"
                        @click="showConfirmModal">
                    <icon name="save"></icon>
                    บันทึกจบ
                </button>
                <button class="btn btn-danger margin"
                        @click="goToEmployeeList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </div>
        <div class="row border border-dark">
            <div style="padding: 10px">
                <h5>เงินค้ำประกัน</h5>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>ยอดเงินค้ำประกัน</label><span style="color: red ; font-weight: bold">*</span>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control"
                               v-model="form.quarantee.amount_total"
                               placeholder="ยอดเงินค้ำประกัน"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>ยอดเงินประกันชำระแล้ว</label><span style="color: red ; font-weight: bold">*</span>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control"
                               v-model="form.quarantee.paid"
                               placeholder="ประกันชำระแล้ว"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>ส่วนที่เหลือหักครั้งละ</label><span style="color: red ; font-weight: bold">*</span>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control"
                               v-model="form.quarantee.amount"
                               placeholder="หักครั้งละ"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>หักเงินประกัน</label><span style="color: red ; font-weight: bold">*</span>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 pl-5">
                        <input class="form-check-input" type="radio" value="1"
                               v-model="form.quarantee.paid_week"
                               id="defaultCheck1">
                        <label class="form-check-label" for="defaultCheck1">
                            หักวีคที่ 1
                        </label><br/>
                        <input class="form-check-input" type="radio" value="2"
                               v-model="form.quarantee.paid_week"
                               id="defaultCheck2">
                        <label class="form-check-label" for="defaultCheck2">
                            หักวีคที่ 2
                        </label><br/>
                        <input class="form-check-input" type="radio" value="3"
                               v-model="form.quarantee.paid_week"
                               id="defaultCheck3">
                        <label class="form-check-label" for="defaultCheck3">
                            หักทั้ง 2 วีค
                        </label>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>ยอดค้ำประกันจ่ายคืน</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control"
                               v-model="form.quarantee.paid_back"
                               placeholder="ประกันจ่ายคืน"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>วันที่จ่ายยอดค้ำประกันคืน</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <date-picker
                            v-model="form.quarantee.paid_back_date"
                            :lang="lang"
                            :format="changeFormat"
                            class="w-100"
                            placeholder="วันที่จ่ายยอดค้ำประกันคืน">
                        </date-picker>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>หมายเหตุ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control"
                               v-model="form.quarantee.reason"
                               placeholder="หมายเหตุ"/>
                    </b-col>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px">
            <div class="col-sm-6 border border-dark">
                <div style="padding: 10px">
                    <h5>ผู้ค้ำประกันคนที่ 1</h5>
                    <div class="row form-group">
                        <div class="col-5 text-right">
                            ชื่อพนักงานที่ค้ำประกัน
                        </div>
                        <div class="col-6">
                            <multiselect v-model="quarantor1.employee_quarantee"
                                         :options="employee_all"
                                         :show-labels="false"
                                         label="name"
                                         placeholder="พนักงานค้ำประกัน"
                                         @input="setDataEmployeeQuarantee"
                                         track-by="id">
                            </multiselect>
                        </div>
                    </div>
                    <div class="row form-group">
                        <b-col sm="5" class="col-sm-5 text-right">
                            <label>ชื่อผู้ค้ำประกัน</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <input type="text" class="form-control"
                                   v-model="quarantor1.name"
                                   placeholder="ชื่อผู้ค้ำประกัน"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="5" class="col-sm-5 text-right">
                            <label>เลขบัตรประจำตัวประชาชน / passport</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <input type="text" class="form-control"
                                   v-model="quarantor1.citizen_id"
                                   placeholder="เลขบัตรประจำตัวประชาชน"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>วันหมดอายุ</label>
                            <date-picker
                                class="w-100"
                                v-model="quarantor1.expire_date"
                                lang="lang"
                                :format="changeFormat"
                                placeholder="วันหมดอายุ">
                            </date-picker>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>สถานที่ออก</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor1.issue_at"
                                   placeholder="สถานที่ออก"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>ที่อยู่ปัจจุบัน บ้านเลขที่</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor1.house_no"
                                   placeholder="บ้านเลขที่"/>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>ถนน</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor1.road"
                                   placeholder="ถนน"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>จังหวัด</label>
                            <multiselect
                                v-model="quarantor1.province"
                                :options="optionProvince"
                                :show-labels="false"
                                @input="getDistricts1(quarantor1.province)"
                                label="name"
                                placeholder="จังหวัด"
                                track-by="name">
                            </multiselect>

                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>อำเภอ/เขต</label>
                            <multiselect
                                v-model="quarantor1.district"
                                :options="optionDistricts"
                                :show-labels="false"
                                label="name"
                                @input="getSubDistricts1(quarantor1.district)"
                                placeholder="อำเภอ/เขต"
                                track-by="name">
                            </multiselect>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>แขวง / ตำบล</label>
                            <multiselect
                                v-model="quarantor1.sub_district"
                                :options="optionSubDistricts"
                                :show-labels="false"
                                label="name"
                                placeholder="แขวง/ตำบล"
                                track-by="name">
                            </multiselect>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>รหัสไปรษณีย์</label>
                            <input type="text" class="form-control"
                                   v-model="postal_code1"
                                   placeholder="รหัสไปรษณีย์" readonly/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>อาชีพ</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor1.career"
                                   placeholder="อาชีพ"/>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>สถานที่ทำงาน</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor1.company_address"
                                   placeholder="สถานที่ทำงาน"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>ตำแหน่ง</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor1.position"
                                   placeholder="ตำแหน่ง"/>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>ความสัมพันธ์</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor1.relationship"
                                   placeholder="ความสัมพันธ์"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>เบอร์โทรศัพท์</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor1.phone"
                                   placeholder="เบอร์โทรศัพท์"/>
                        </b-col>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 border border-dark">
                <div style="padding: 10px">
                    <h5>ผู้ค้ำประกันคนที่ 2</h5>
                    <div class="row form-group">
                        <div class="col-5 text-right">
                            ชื่อพนักงานที่ค้ำประกัน
                        </div>
                        <div class="col-6">
                            <multiselect v-model="quarantor2.employee_quarantee"
                                         :options="employee_all"
                                         :show-labels="false"
                                         label="name"
                                         @input="setDataEmployeeQuarantee"
                                         placeholder="พนักงานค้ำประกัน"
                                         track-by="id">
                            </multiselect>
                        </div>
                    </div>
                    <div class="row form-group">
                        <b-col sm="5" class="col-sm-5 text-right">
                            <label>ชื่อผู้ค้ำประกัน</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <input type="text" class="form-control"
                                   v-model="quarantor2.name"
                                   placeholder="ชื่อผู้ค้ำประกัน"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="5" class="col-sm-5 text-right">
                            <label>เลขบัตรประจำตัวประชาชน / passport</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <input type="text" class="form-control"
                                   v-model="quarantor2.citizen_id"
                                   placeholder="เลขบัตรประจำตัวประชาชน"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>วันหมดอายุ</label>
                            <date-picker
                                class="w-100"
                                v-model="quarantor2.expire_date"
                                lang="lang"
                                :format="changeFormat"
                                placeholder="วันหมดอายุ">
                            </date-picker>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>สถานที่ออก</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor2.issue_at"
                                   placeholder="สถานที่ออก"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>ที่อยู่ปัจจุบัน บ้านเลขที่</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor2.house_no"
                                   placeholder="บ้านเลขที่"/>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>ถนน</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor2.road"
                                   placeholder="ถนน"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>จังหวัด</label>
                            <multiselect
                                v-model="quarantor2.province"
                                :options="optionProvince"
                                :show-labels="false"
                                @input="getDistricts2(quarantor2.province)"
                                label="name"
                                placeholder="จังหวัด"
                                track-by="name">
                            </multiselect>

                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>อำเภอ/เขต</label>
                            <multiselect
                                v-model="quarantor2.district"
                                :options="optionDistricts"
                                :show-labels="false"
                                label="name"
                                @input="getSubDistricts2(quarantor2.district)"
                                placeholder="อำเภอ/เขต"
                                track-by="name">
                            </multiselect>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>แขวง / ตำบล</label>
                            <multiselect
                                v-model="quarantor2.sub_district"
                                :options="optionSubDistricts"
                                :show-labels="false"
                                label="name"
                                placeholder="แขวง/ตำบล"
                                track-by="name">
                            </multiselect>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>รหัสไปรษณีย์</label>
                            <input type="text" class="form-control"
                                   v-model="postal_code2"
                                   placeholder="รหัสไปรษณีย์" readonly/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>อาชีพ</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor2.career"
                                   placeholder="อาชีพ"/>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>สถานที่ทำงาน</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor2.company_address"
                                   placeholder="สถานที่ทำงาน"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>ตำแหน่ง</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor2.position"
                                   placeholder="ตำแหน่ง"/>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <label>ความสัมพันธ์</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor2.relationship"
                                   placeholder="ความสัมพันธ์"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6">
                            <label>เบอร์โทรศัพท์</label>
                            <input type="text" class="form-control"
                                   v-model="quarantor2.phone"
                                   placeholder="เบอร์โทรศัพท์"/>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
        <!--<pre class="alert alert-danger text-left">{{form}}</pre>-->
        <b-modal hide-header hide-footer ref="confirmEmp">
            <confirm-emp-modal @submit="saveEmployee">
            </confirm-emp-modal>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex"
import DatePicker from 'vue2-datepicker'
import Multiselect from "vue-multiselect";
import moment from "moment";
import confirmEmpModal from "../../../Utility/ConfirmEmpModal";

import {canViewSuperAdmin} from "../../../../util/Permissions";

export default {
    name: "employee-quarantee",
    props: {
        status_bar: {default: false},
    },
    components: {
        DatePicker,
        Multiselect,
        confirmEmpModal
    },
    created() {
        this.$store.dispatch("Employee/getEmployeeDataAll").then(employee => {
            this.employee_all = employee;
        })
    },
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            employee_all: [],
        }
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            form: state => {
                return state.Employee.employeeForm;
            },

            optionProvince: state => {
                return state.Common.province;
            },
            optionDistricts: state => {
                return state.Common.districts;
            },
            optionSubDistricts: state => {
                return state.Common.sub_districts;
            },
            quarantor2: state => {
                return state.Employee.quarantor2;
            },
            quarantor1: state => {
                return state.Employee.quarantor1;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
        postal_code1() {
            let zipcode = '';
            if (this.quarantor1.district && this.quarantor1.sub_district) {
                zipcode = this.quarantor1.sub_district.zipcode;
                return zipcode;
            } else {
                return zipcode;
            }
        },
        postal_code2() {
            let zipcode = '';
            if (this.quarantor2.district && this.quarantor2.sub_district) {
                zipcode = this.quarantor2.sub_district.zipcode;
                return zipcode;
            } else {
                return zipcode;
            }
        }
    },
    methods: {
        showConfirmModal() {
            this.$refs.confirmEmp.show();
        },
        getDistricts1(province) {
            this.quarantor1.province_id = province.id;
            this.quarantor1.sub_district = "";
            this.quarantor1.district = "";
            if (province) {
                //console.log(province.code);
                this.$store.dispatch('Common/setDistrict', province.code);
            } else {
                this.quarantor1.district = "";
                this.quarantor1.sub_district = "";
            }
        },
        getSubDistricts1(districts) {
            this.quarantor1.district_id = districts.id;
            this.quarantor1.sub_district = "";
            if (districts) {
                this.$store.dispatch('Common/setSubDistrict', districts.district_id);
                //console.log(this.quarantor1)
            } else {
                this.quarantor1.sub_district = "";
            }
        },
        getDistricts2(province) {
            this.quarantor2.province_id = province.id;
            this.quarantor2.sub_district = "";
            this.quarantor2.district = "";
            if (province) {
                this.$store.dispatch('Common/setDistrict', province.code);
            } else {
                this.quarantor2.district = "";
                this.quarantor2.sub_district = "";
            }
        },
        getSubDistricts2(districts) {
            this.quarantor2.district_id = districts.id;
            this.quarantor2.sub_district = "";
            if (districts) {
                this.$store.dispatch('Common/setSubDistrict', districts.district_id);
            } else {
                this.quarantor2.sub_district = "";
            }
        },
        goToEmployeeList() {
            this.$router.push({
                name: "employee"
            })
        },
        goToBackWord() {
            this.$router.push({
                name: "employee-information-salary"
            })
        },
        goToForward() {
            if (this.validateData()) {
                this.$router.push({
                    name: "employee-social-insurance"
                })
            }
        },
        saveEmployee(value) {
            if (value) {
                this.form.user_id = this.user.id;
                if (this.validateData()) {
                    this.$store.dispatch("Employee/saveEmployee", {
                        id: this.form.id,
                        data: this.form
                    });
                    this.goToEmployeeList();
                }
            } else {
                this.$refs.confirmEmp.hide();
            }
        },
        validateData() {
            if (!this.form.quarantee.amount_total) {
                alert("กรุณากรอกเงินค้ำประกัน")
            } else if (!this.form.quarantee.paid) {
                alert("กรุณากรอกยอดเงินประกันที่ชำระแล้ว")
            } else if (!this.form.quarantee.amount) {
                alert("กรุณากรอก ยอดเงินที่ต้องการหักครั้งละ")
            } else {
                this.form.quarantor = [];
                if (this.form.quarantee.paid_back_date) {
                    this.form.quarantee.paid_back_date = moment(this.form.quarantee.paid_back_date).format('YYYY-MM-DD');
                }
                //quarantee1
                if (this.quarantor1.name) {
                    this.quarantor1.expire_date = moment(this.quarantor1.expire_date).format("YYYY-MM-DD");
                    this.quarantor1.district_id = this.quarantor1.district ? this.quarantor1.district.id : null;
                    this.quarantor1.province_id = this.quarantor1.province ? this.quarantor1.province.id : null;
                    this.quarantor1.sub_district_id = this.quarantor1.sub_district ? this.quarantor1.sub_district.id : null;
                    this.form.quarantor.push(this.quarantor1);
                }
                //quarantee2
                if (this.quarantor2.name) {
                    this.quarantor2.expire_date = moment(this.quarantor2.expire_date).format("YYYY-MM-DD");
                    this.quarantor2.district_id = this.quarantor2.district ? this.quarantor2.district.id : null;
                    this.quarantor2.province_id = this.quarantor2.province ? this.quarantor2.province.id : null;
                    this.quarantor2.sub_district_id = this.quarantor2.sub_district ? this.quarantor2.sub_district.id : null;
                    this.form.quarantor.push(this.quarantor2);
                }
                return true;
            }
        },
        setDataEmployeeQuarantee() {
            if (this.quarantor1.employee_quarantee) {
                this.quarantor1.employee_quarantee_id = this.quarantor1.employee_quarantee.id;
                this.quarantor1.name = this.quarantor1.employee_quarantee.name;
                this.quarantor1.citizen_id = this.quarantor1.employee_quarantee.citizen ? this.quarantor1.employee_quarantee.citizen.citizen_id : '';
            }
            if (this.quarantor2.employee_quarantee) {
                this.quarantor2.employee_quarantee_id = this.quarantor2.employee_quarantee.id;
                this.quarantor2.name = this.quarantor2.employee_quarantee.name;
                this.quarantor2.citizen_id = this.quarantor2.employee_quarantee.citizen ? this.quarantor2.employee_quarantee.citizen.citizen_id : '';
            }
        }
    }
}
</script>

<style scoped>
body {
    font-family: Arial, Helvetica, sans-serif;
}

* {
    box-sizing: border-box;
}

.form-inline {
    display: flex;
    flex-flow: row wrap;
    align-items: left;
}

.form-inline label {
    margin: 5px 10px 5px 0;
}

.form-inline input {
    vertical-align: middle;
    margin: 5px 10px 5px 0;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #ddd;
}

.form-inline button {
    padding: 10px 20px;
    border: 1px solid #ddd;
    color: white;
    cursor: pointer;
}

.form-inline button:hover {

}

@media (max-width: 800px) {
    .form-inline input {
        margin: 10px 0;
    }

    .form-inline {
        flex-direction: column;
        align-items: stretch;
    }
}

.padding {
    padding: 20px;
}

.margin {
    margin: 10px;
}
</style>
